import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: checkText(settings),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltsvorstellung (bitte als Bruttogehalt in Vollzeit angeben)</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Jährlichen Gehaltswunsch eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={errors.salaryRequest}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEntranceDate">
                <Form.Label>Frühestmöglicher Starttermin</Form.Label>
                <CustomFormControl
                    colors={colors}
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>
            {
                values.researchAssistant.map((field, index) =>
                    <Form.Group className="mb-3" key={index}>
                        <Form.Check
                            id={field.displayName}
                            label={field.displayName}
                            onChange={(event) => {
                                field.onChange(event);
                                handleChange(event);
                            }}
                        />
                    </Form.Group>
                )
            }
            {
                values.trainee.map((field, index) =>
                    <Form.Group className="mb-3" key={index}>
                        <Form.Check
                            id={field.displayName}
                            label={field.displayName}
                            onChange={(event) => {
                                field.onChange(event);
                                handleChange(event);
                            }}
                        />
                    </Form.Group>
                )
            }
      </>
    );
};